import { NotificaResponseDTO } from '@framework/api-client';
import { assertNever } from '@framework/engine';
import { t } from '@framework/i18n';
import { Tag } from 'antd';
import styled from 'styled-components';
import { NotificationPriority } from '../NotificationTypes';

const translations = {
  BASSA: t('notification-drawer.priority-tag.bassa', 'BASSA'),
  NORMALE: t('notification-drawer.priority-tag.normale', 'NORMALE'),
  ALTA: t('notification-drawer.priority-tag.alta', 'ALTA'),
  URGENTE: t('notification-drawer.priority-tag.urgente', 'URGENTE'),
};

const Wrapper = styled.span`
  margin-right: 4px;
`;
function getPriorityTag(priorita: NotificationPriority) {
  const text = (
    <span>
      <span className="sr-only">
        {t('notification-drawer.priority-tag.priorita', 'Priorità:')}{' '}
      </span>
      {translations[priorita]}
    </span>
  );

  switch (priorita) {
    case NotificationPriority.BASSA:
      return <Tag>{text}</Tag>;
    case NotificationPriority.NORMALE:
      return <Tag color="blue">{text}</Tag>;
    case NotificationPriority.ALTA:
      return <Tag color="orange">{text}</Tag>;
    case NotificationPriority.URGENTE:
      return <Tag color="red">{text}</Tag>;
    default:
      console.warn("[NotificationPriorityTag] Nessuna priorità trovata: ", {priorita}); // prettier-ignore
      assertNever(priorita);
  }
}

interface NotificationTagProps {
  notification: NotificaResponseDTO;
}

/**
 * Tag della priorità di una notifica
 */
export function NotificationPriorityTag(props: NotificationTagProps) {
  const { notification } = props;
  if (!notification.priorita) return null;

  return (
    <Wrapper>
      {getPriorityTag(notification.priorita as NotificationPriority)}
    </Wrapper>
  );
}
